import React from 'react';
import PageContent from './page-content';
import DesignToCodeLayout from '../layout/layout';
import { useParams } from 'react-router';

const DesignToCodeGenerator = () => {
  const breadcrumb = [
    {
      type: 'link',
      link: '/design-to-code',
      text: 'Design to Code',
    },
    {
      type: 'text',
      text: 'Code Generator',
    },
  ];

  const { id } = useParams();

  return (
    <DesignToCodeLayout breadcrumb={breadcrumb}>
      <PageContent docId={id}></PageContent>
    </DesignToCodeLayout>
  );
};

export default DesignToCodeGenerator;
